export default "__VITE_ASSET__BKO56GpT__"